import { render } from "./PayeeSummary.vue?vue&type=template&id=3dbe352d&scoped=true"
import script from "./PayeeSummary.vue?vue&type=script&lang=js"
export * from "./PayeeSummary.vue?vue&type=script&lang=js"

import "./PayeeSummary.vue?vue&type=style&index=0&id=3dbe352d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dbe352d"]])

export default __exports__